var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppshare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.76667 4.66657C6.76667 3.89337 7.39347 3.26657 8.16667 3.26657H19.8333C20.6065 3.26657 21.2333 3.89337 21.2333 4.66657V23.3332C21.2333 24.1064 20.6065 24.7332 19.8333 24.7332H8.16667C7.39347 24.7332 6.76667 24.1064 6.76667 23.3332V4.66657ZM8.16667 1.3999C6.36254 1.3999 4.90001 2.86244 4.90001 4.66657V23.3332C4.90001 25.1374 6.36254 26.5999 8.16667 26.5999H19.8333C21.6375 26.5999 23.1 25.1374 23.1 23.3332V4.66657C23.1 2.86244 21.6375 1.3999 19.8333 1.3999H8.16667ZM14 19.2499C13.0335 19.2499 12.25 20.0334 12.25 20.9999C12.25 21.9664 13.0335 22.7499 14 22.7499H14.0117C14.9782 22.7499 15.7617 21.9664 15.7617 20.9999C15.7617 20.0334 14.9782 19.2499 14.0117 19.2499H14Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppshare);
export default __webpack_public_path__ + "static/media/appshare.6ff69739cac77e1379b95b57106f3f1d.svg";
export { ForwardRef as ReactComponent };